<template>
  <Card>
    <CardHeading :heading="heading" :showCapacity="false" :showButton="false" />
    <div class="grid" v-if="filters.length">
      <div
        v-for="filter in filters"
        :key="filter.id"
        class="grid__cell col6-of-12--medium-up"
      >
        <span v-if="filter.filterOptions && filter.filterOptions.length">
          <div
            v-if="
              (agencyOPP || servicePartnerProfile) &&
                !filter.multiple &&
                !filter.multipleAtDirectory
            "
          >
            <label class="mb-md fs-sm" style="max-width: 300px;">
              {{ filter.label }}
              <div class="select">
                <select
                  @change="
                    handleDropdownChange({
                      filter: filter.id,
                      option: $event.target.value,
                    })
                  "
                >
                  <option class="fs-sm" value>Select one</option>
                  <option
                    v-for="item in filter.filterOptions"
                    :key="item.id"
                    :value="item.id"
                    :selected="checkSelectedDropDown(item.id, filter.id)"
                    >{{ item.name }}</option
                  >
                </select>
              </div>
            </label>
          </div>
          <div class="mb-md" v-else>
            <label
              class="fs-sm"
              style="margin-bottom: 0.5rem; font-weight: 600"
            >
              {{ filter.label }}
            </label>
            <div
              v-for="item in filter.filterOptions"
              :key="item.id"
              class="custom-checkbox custom-checkbox-tick"
            >
              <input
                type="checkbox"
                :id="item.id"
                :value="item.id"
                @change="handleCheckboxChange(item.id, filter.id)"
                :checked="checkSelectedOption(item.id, filter.id)"
              />
              <label class="fs-sm" style="font-weight: 400;" :for="item.id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </span>
      </div>
    </div>
    <CardText v-else :text="getEmptyCardText()" />
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card';
import CardHeading from '@/components/DesignSystem/CardHeading';
import CardText from '@/components/DesignSystem/CardText';
export default {
  name: 'FiltersContentSection',
  props: {
    namespace: String,
    heading: {
      type: String,
      default: 'Filters',
    },
    options: {
      type: Array,
    },
    servicePartnerProfile: Boolean,
    agencyOPP: Boolean,
    vendorOPP: Boolean,
    storeInfo: Object,
  },
  components: { CardText, CardHeading, Card },
  computed: {
    profileData() {
      return this.$store.getters[
        `${this.namespace}/${
          this.storeInfo ? this.storeInfo.get : 'profileData'
        }`
      ];
    },
    filters() {
      if (this.servicePartnerProfile || this.agencyOPP) {
        let actionType = 'filters';
        if (this.servicePartnerProfile) {
          actionType = `agencyDetailProfile/getFilters`;
        }
        const items = this.$store.getters[`${this.namespace}/${actionType}`]
          .filter(i => !i.onlyMatchmaking)
          .map(i => ({ ...i, label: i.name }));
        return items.sort((a, b) => {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
        });
      } else {
        return this.options.map(option => ({
          ...option,
          filterOptions: this.$store.getters[`${this.namespace}/${option.id}`],
        }));
      }
    },
  },
  methods: {
    handleCheckboxChange(id, type) {
      let payload = {
        id,
        type,
      };
      let dispatchType = this.namespace;
      if (this.servicePartnerProfile || this.agencyOPP || this.vendorOPP) {
        payload = payload.id;
        if (this.servicePartnerProfile) {
          dispatchType += `/agencyDetailProfile`;
        }
      }
      this.$store.dispatch(`${dispatchType}/handleCheckboxChange`, payload);
    },
    handleDropdownChange(payload) {
      let dispatchType = this.namespace;
      if (this.servicePartnerProfile) {
        dispatchType += `/agencyDetailProfile`;
      }
      this.$store.dispatch(`${dispatchType}/handleDropdownChange`, payload);
    },
    checkSelectedOption(id, type) {
      if (this.servicePartnerProfile || this.agencyOPP) {
        type = 'filterOptions';
      }
      if (!this.profileData[type]) return false;
      for (let item of this.profileData[type]) {
        if (item.id === id || item === id) {
          return true;
        }
      }
      return false;
    },
    checkSelectedDropDown(id, type) {
      if (this.servicePartnerProfile || this.agencyOPP) {
        type = 'filterOptions';
      }
      if (!this.profileData[type]) return;
      return this.profileData[type].includes(id);
    },
    getEmptyCardText() {
      if (this.agencyOPP) {
        return `No ${this.heading.toLowerCase()} have been configured by the owner of this directory.`;
      }
      return `No ${this.heading.toLowerCase()} have been configured for this directory.`;
    },
  },
};
</script>
